import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Table, DialogContent } from '@mui/material';
import useStyles from '../styles';

const ReviewDataPayoffRequest = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <Table classes={{ root: classes.tableRoot }} component="div">
      <DialogContent>
        <Typography sx={{ fontSize: 20, marginTop: 2 }} align="justify">
          {t('COMMON.PAYOFF_CONFIRMATION_DESCRIPTION')}
        </Typography>
      </DialogContent>
    </Table>
  );
};

export default ReviewDataPayoffRequest;
